import { createFileRoute } from '@tanstack/react-router';
import { ProposalsTab } from '@/features/carriers/proposals/proposals-tab';

// S13 · Proposals (recipe repairs) (07 §4).
export const Route = createFileRoute('/_app/carriers/$code/proposals')({
  component: ProposalsTab,
});
